<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card prominent>
        <v-toolbar-title>{{isEditGeofence ? `Chỉnh sửa `: `Thêm `}} vùng giới hạn</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="exit()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="input-form">
        <v-form v-model="formValid" ref="form">
          <v-text-field v-model="form.name" label="Tên vùng" :rules="[validate.required]"></v-text-field>
          <v-text-field
            v-model="form.radius"
            label="Bán kính"
            suffix="(m)"
            mask="######"
            :rules="[validate.required, validate.numeric]"
          ></v-text-field>
          <v-text-field v-model="form.description" label="Ghi chú"></v-text-field>
          <div class="left pa-3">
            <v-checkbox label="Cảnh báo đi vào" v-model="form.moveIn"></v-checkbox>
          </div>
          <div class="left pa-3">
            <v-checkbox label="Cảnh báo đi ra" v-model="form.moveOut"></v-checkbox>
          </div>
          <div class="clear"></div>
          <v-btn block round color="success" @click="submit()" :loading="isLoading">Hoàn thành</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import validate from '@/utils/validate';

export default {
  name: 'geofence-add',
  data () {
    return {
      formValid: false,
      isLoading: false,
      validate: validate,
      form: {
        name: '',
        centerX: 0,
        centerY: 0,
        moveIn: true,
        moveOut: true,
        radius: 200,
        description: '',
        applyAll: true
      }
    };
  },
  computed: {
    ...mapGetters([
      'geofences',
      'selectedGeofence',
      'addGeofenceLatLng',
      'isEditGeofence'
    ])
  },
  watch: {
    addGeofenceLatLng () {
      this.form.centerX = parseInt(
        this.addGeofenceLatLng.lng * Math.pow(10, 6),
        10
      );
      this.form.centerY = parseInt(
        this.addGeofenceLatLng.lat * Math.pow(10, 6),
        10
      );
    },
    'form.radius' () {
      let radius = 200;
      if (this.form.radius >= 200) {
        radius = this.form.radius;
      }
      this.SET_ADD_GEOFENCE_RADIUS(parseInt(radius, 10));
    },
    isEditGeofence () {
      if (this.isEditGeofence) {
        this.form.id = this.selectedGeofence.id;
        this.form.name = this.selectedGeofence.name;
        this.form.radius = this.selectedGeofence.radius;
        this.form.moveIn = this.selectedGeofence.moveIn;
        this.form.moveOut = this.selectedGeofence.moveOut;
        this.form.centerX = this.selectedGeofence.centerX;
        this.form.centerY = this.selectedGeofence.centerY;
      }
    }
  },
  methods: {
    ...mapActions(['getGeofences', 'createGeofence', 'updateGeofence']),
    ...mapMutations([
      'SET_SELECTED_GEOFENCE',
      'SET_ADD_GEOFENCE_STATE',
      'SET_EDIT_GEOFENCE_STATE',
      'ADD_GEOFENCE',
      'SET_ADD_GEOFENCE_RADIUS'
    ]),
    submit () {
      if (this.formValid) {
        this.isLoading = true;
        if (!this.isEditGeofence) {
          this.createGeofence(this.form)
            .then(res => {
              this.isLoading = false;
              this.ADD_GEOFENCE(res);
              this.exit();
              window.getApp.showMessage('Tạo vùng giới hạn thành công');
            })
            .catch(_ => {
              this.isLoading = false;
              window.getApp.showMessage(
                'Tạo thất bại, vui lòng thử lại',
                'error'
              );
            });
        } else {
          this.updateGeofence(this.form)
            .then(res => {
              this.getGeofences().then(_ => {
                this.isLoading = false;
                window.getApp.showMessage('Cập nhật vùng giới hạn thành công');
                this.exit();
              });
              // .catch(_ => {
              //   this.isLoading = false;
              //   window.getApp.showMessage(
              //     'Cập nhật vùng giới hạn thành công'
              //   );
              //   this.exit();
              // });
            })
            .catch(_ => {
              this.isLoading = false;
              window.getApp.showMessage(
                'Cập nhật thất bại, vui lòng thử lại',
                'error'
              );
            });
        }
      } else {
        this.$refs.form.validate();
      }
    },
    clear () {
      this.form = {
        name: '',
        centerX: 0,
        centerY: 0,
        moveIn: true,
        moveOut: true,
        radius: 200,
        description: ''
      };
    },
    exit () {
      this.SET_ADD_GEOFENCE_STATE(false);
      this.SET_EDIT_GEOFENCE_STATE(false);
      this.clear();
    }
  }
};
</script>
<style scoped>
.input-form {
  background: white;
  height: calc(100vh - 128px);
}
</style>



// WEBPACK FOOTER //
// src/pages/geofence/components/Add.vue